import { createSlice } from "@reduxjs/toolkit";
import appConst from "../Utilities/appConst.json";

const personalDetailsSlice = createSlice({
  name: "personalDetails",
  initialState: {
    unvalidateFields: [],
    isValid: false,
    isFormSubmited: false,
    isCheckedBusinessInvoice: false,
    isCheckedOtherReceiver: false,
    showAlert: false,
    senderPersonalDetails: {
      city: "",
      street: "",
      houseNumber: "",
      phoneNumber: "",
      areaCode: "",
      email: "",
    },
    receiverPersonalDetails: {
      city: "",
      street: "",
      houseNumber: "",
      phoneNumber: "",
      areaCode: "",
      email: "",
    },
    businessPersonalDetails: {
      company: "",
      companyId: "",
      city: "",
      street: "",
    },
    collectionBucketPersonalDetails: {
      phoneNumber: "",
      areaCode: "",
    },
  },
  reducers: {
    setUnvalidateFieldsList: (state, action) => {
      // if there is an error in the field and it does not appear on the unvalidateFields list- add it
      if (action.payload.isError) {
        if (
          !state.unvalidateFields.find((item) => item === action.payload.id)
        ) {
          state.unvalidateFields.push(action.payload.id);
        }
      } else {
        // if the field is valid and it appears on the unvalidateFields list- remove it
        if (state.unvalidateFields.find((item) => item === action.payload.id)) {
          const index = state.unvalidateFields.indexOf(action.payload.id);
          state.unvalidateFields.splice(index, 1);
        }
      }
      state.isValid = state.unvalidateFields.length === 0;
    },

    setIsFormSubmited: (state, action) => {
      state.isFormSubmited = action.payload.isFormSubmited;
    },
    setIsCheckedBusinessInvoice: (state, action) => {
      state.isCheckedBusinessInvoice = action.payload.isCheckedBusinessInvoice;
    },
    setIsCheckedOtherReceiver: (state, action) => {
      state.isCheckedOtherReceiver = action.payload.isCheckedOtherReceiver;
    },
    setShowAlert: (state, action) => {
      state.showAlert = action.payload.showAlert;
    },
    resetUnvalidateFieldsList: (state, action) => {
      state.unvalidateFields = [];
      state.isValid = true;
    },
    setSenderPersonalDetails: (state, action) => {
      state.senderPersonalDetails = action.payload;
    },
    setReceiverPersonalDetails: (state, action) => {
      state.receiverPersonalDetails = action.payload;
    },
    setBusinessPersonalDetails: (state, action) => {
      state.businessPersonalDetails = action.payload;
    },
    setCollectionBucketPersonalDetails: (state, action) => {
      state.collectionBucketPersonalDetails = action.payload;
    },
  },
});

export const personalDetailsActions = personalDetailsSlice.actions;
export default personalDetailsSlice;
